import { DateTime } from 'luxon';
import { makeAutoObservable } from 'mobx';

export type LoanOrg = {
  id: number;
  accountCode?: string;
  contactExternalId?: string;
  ncExternalId?: string;
  isLender: boolean;
};

type LoanOrganisationApiResponse = LoanOrg;

export type LoanAccountsUpdateApiRequest = {
  org1: LoanOrganisationApiResponse;
  org2: LoanOrganisationApiResponse;
  name: string;
  isRecharger: boolean;
  isBrag: boolean;
};

export type LoanAccountsCreateApiRequest = LoanAccountsUpdateApiRequest;

type LoanAccountsApiResponse = LoanAccountsUpdateApiRequest & {
  id: number;
  created: DateTime;
  type?: LoanAccountType;
};

export enum LoanAccountType {
  account = 'account',
  contact = 'contact',
}

export class LoanAccount {
  id: number = null;
  created: DateTime = null;
  org1: LoanOrg = {
    id: null,
    ncExternalId: '',
    contactExternalId: '',
    isLender: false,
  };
  org2: LoanOrg = {
    id: null,
    ncExternalId: '',
    contactExternalId: '',
    isLender: false,
  };
  name: string = '';
  isRecharger: boolean = false;
  isBrag: boolean = false;
  type?: LoanAccountType = LoanAccountType.account;

  constructor() {
    makeAutoObservable(this);
  }

  toApi = (): LoanAccountsUpdateApiRequest => ({
    org1: this.org1,
    org2: this.org2,
    name: this.name,
    isRecharger: this.isRecharger,
    isBrag: this.isBrag,
  });

  static fromApi(apiData: LoanAccountsApiResponse): LoanAccount {
    const intercompanyLoan = new LoanAccount();

    intercompanyLoan.id = apiData.id;
    intercompanyLoan.created = apiData.created;
    intercompanyLoan.org1 = apiData.org1;
    intercompanyLoan.org2 = apiData.org2;
    intercompanyLoan.name = apiData.name;
    intercompanyLoan.isRecharger = apiData.isRecharger;
    intercompanyLoan.isBrag = apiData.isBrag;
    intercompanyLoan.type = apiData.type;

    return intercompanyLoan;
  }
}
